import { Navigation } from "./navigation";
import { Collapse, Alert } from "bootstrap";
import { Distributors } from "./pages/distributors";
import { Newsletter } from "./newsletter";
import { Forms } from "./forms";
import { Header } from "./header";
import { SectionAnimations } from "./section-animations";
import { BackToTop } from "./back-to-top";
import { StatWidget } from "./widgets/stat-widget";
import { Filters } from "./filters";
import { VideoPlayer } from "./video-player";
import { Accordion } from "./accordion";
import { Product } from "./pages/product";
import { ProductList } from "./pages/product-list";
import {Carousel} from "./carousel";
import { TeamMembersList } from "./pages/team-member-list";
import { CountryStateSelector } from "./country-state-selector";
import { DismissableNotice } from "./dismissable-notice";
import { TabHelper } from "./helpers/tab-helper";
import { TeamMemberWidget } from "./widgets/team-member-widget";
import { SocialShare } from "./social-share";
import { DistributorModal } from "./widgets/distributor-modal";  
import {ConsentBanner} from "./consent-banner";
import {ArticleList} from "./pages/article-list";
import {ResearchList} from "./pages/research-list";
import {ResourceListFactory} from "./pages/resource-list-factory";
import {Users} from "./users";                               
import {TabbedTable} from "./widgets/tabbed-table";
import {Search} from "./search";
import {BookmarkNavCount} from "./widgets/bookmark-nav-count";

export class App {

	constructor() {

		const init = [
			new Newsletter(),
			new Forms(),
			new Distributors(),
			new Header(true),
			new CountryStateSelector(),
			new Navigation(true),
			new SectionAnimations(),
			new BackToTop(),
			new StatWidget(),
			new Filters(),
			new VideoPlayer(),
			new Accordion(),
            new Product(),
			new TabHelper(),
			new ProductList(),
            new ResourceListFactory(),           
			new TeamMembersList(),			
			new DismissableNotice(),
			new SocialShare(),
            new Carousel(),
			new TeamMemberWidget(),
			new DistributorModal(),
			new ConsentBanner(),
			new ArticleList(),
			new ResearchList(),
			new TabbedTable(),
			new Search(),
			new Users(),
			new BookmarkNavCount()
		];

		const bootstrapInit = [Alert, Collapse]; //bootstrap used methods

        // Lazy-load heavy, page-specific features
        // Swiper carousels
        if (document.querySelector('.swiper-container')) {
            import(/* webpackChunkName: "carousel" */ './carousel').then(m => new m.Carousel());
        }

        // Google Maps - Distributors
        // if (document.querySelector('.locator-widget')) {
        //     import(/* webpackChunkName: "distributors" */ './pages/distributors').then(m => new m.Distributors());
        // }

        // Success stories list + map (includes MarkerClusterer/Maps usage)
        if (document.querySelector('.success-stories-section') || document.querySelector('.success-stories-list')) {
            import(/* webpackChunkName: "success-story-list" */ './pages/success-story-list').then(m => new m.SuccessStoryList());
        }

		// FullCalendar widget
		if (document.querySelector('.calendar')) {
			import(/* webpackChunkName: "event-calendar" */ './widgets/event-calendar').then(m => new m.EventCalendar());
		}
	}

}


function documentReady(fn: () => void) {
	if (document.readyState === "complete" || document.readyState === "interactive") {
		setTimeout(fn, 1);
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}


documentReady(() => {
	new App();
});

